import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import useIsAuthenticated from "react-auth-kit/hooks/useIsAuthenticated";
import useSignOut from "react-auth-kit/hooks/useSignOut";

const SecureRoute = ({ children, fallbackPath = "/login" }) => {
  const isAuthenticated = useIsAuthenticated();
  const signOut = useSignOut();
  const location = useLocation();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // Ensure the wrapper component runs after navRouter is ready
    setMounted(true);
  }, []);

  if (!mounted) return null;

  if (!isAuthenticated) {
    // If not authenticated, sign out and redirect to fallback path
    console.warn("User is not authenticated, redirecting to login.");
    sessionStorage.clear(); // Clear session storage
    localStorage.clear(); // Clear local storage
    signOut();
    return <Navigate to={fallbackPath} state={{ from: location }} />;
  }

  return children;
};

export default SecureRoute;